<div class="card">
    <app-header titulo="Perfis de Acessos" descricao=""></app-header>

    <a [routerLink]="['novo']"><button pButton icon="pi pi-plus" label="Novo Perfil"></button></a>

    <app-perfil-dialog [visivel]="perfilDialog" [perfilParam]="perfil"
    (fechar)="fechaPerfilDialog()"></app-perfil-dialog>

    <div class="mt-3">
        <p-table [value]="perfis" dataKey="id" editMode="row" >
            <ng-template pTemplate="header">
                <tr>
                    <th>Nome</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-perfil>
                <tr>
                    <td>{{ perfil.nomePerfil }}</td>
                    <td>
                        <a [routerLink]="['editar', perfil.id]"><p-button
                            icon="pi pi-pencil"
                            [rounded]="true"
                            [text]="true"
                            severity="info"
                            
                            aria-label="Editar"
                            ></p-button></a>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>